export const getTimeRange = (filter) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
    switch(filter) {
        case 'thisWeek':
            const thisWeekStart = new Date(today);
            thisWeekStart.setDate(today.getDate() - today.getDay());
            return {
                from: Math.floor(thisWeekStart.getTime() / 1000),
                to: Math.floor(Date.now() / 1000)
            };
        case 'last7Days':
            const last7Days = new Date(today);
            last7Days.setDate(today.getDate() - 7);
            return {
                from: Math.floor(last7Days.getTime() / 1000),
                to: Math.floor(Date.now() / 1000)
            };
        case 'last30Days':
            const last30Days = new Date(today);
            last30Days.setDate(today.getDate() - 30);
            return {
                from: Math.floor(last30Days.getTime() / 1000),
                to: Math.floor(Date.now() / 1000)
            };
        case 'thisMonth':
            const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
            return {
                from: Math.floor(thisMonthStart.getTime() / 1000),
                to: Math.floor(Date.now() / 1000)
            };
        case 'lastMonth':
            const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
            return {
                from: Math.floor(lastMonthStart.getTime() / 1000),
                to: Math.floor(lastMonthEnd.getTime() / 1000)
            };
        case 'thisYear':
            const thisYearStart = new Date(now.getFullYear(), 0, 1);
            return {
                from: Math.floor(thisYearStart.getTime() / 1000),
                to: Math.floor(Date.now() / 1000)
            };
        case 'lastYear':
            const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
            const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59);
            return {
                from: Math.floor(lastYearStart.getTime() / 1000),
                to: Math.floor(lastYearEnd.getTime() / 1000)
            };
        case 'all':
            // Sin rango: el backend devuelve el historial completo
            return { from: undefined, to: undefined };
        default:
            return { from: undefined, to: undefined };
    }
};

export const getTimeFilters = (t) => [
    { key: 'all', label: t('account.timeFilter.all') },
    { key: 'thisWeek', label: t('account.timeFilter.thisWeek') },
    { key: 'last7Days', label: t('account.timeFilter.last7Days') },
    { key: 'last30Days', label: t('account.timeFilter.last30Days') },
    { key: 'thisMonth', label: t('account.timeFilter.thisMonth') },
    { key: 'lastMonth', label: t('account.timeFilter.lastMonth') },
    { key: 'thisYear', label: t('account.timeFilter.thisYear') },
    { key: 'lastYear', label: t('account.timeFilter.lastYear') }
];
